import { Instagram, Navigation } from "lucide-react";
import Logo from "./Logo";
import { Reveal } from "./Reveal";
import { WhatsAppIcon, TikTokIcon } from "./icons";
import { WHATSAPP_URL, MAPS_URL, INSTAGRAM_URL, TIKTOK_URL } from "./config";

export default function FinalCta() {
  return (
    <footer className="relative overflow-hidden bg-choco text-cream">
      <div
        aria-hidden="true"
        className="dots-pattern absolute -left-20 top-10 h-64 w-64 opacity-10"
      />
      <div
        aria-hidden="true"
        className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-rose/20 blur-3xl"
      />

      <div className="relative mx-auto max-w-4xl px-4 py-16 text-center sm:px-8 sm:py-20">
        <Reveal>
          <span className="inline-block rounded-full bg-cream/10 px-5 py-2 font-hand text-2xl font-semibold text-gold">
            ¡Manos a la masa!
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-3xl font-semibold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
            ¿Listo para darle vida a tu{" "}
            <em className="font-light italic text-rose">próxima creación</em>{" "}
            pastelera?
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-cream/70 sm:text-lg">
            Contáctanos hoy mismo o visítanos en Plaza Quil. ¡Estamos listos
            para asesorarte!
          </p>
        </Reveal>
        <Reveal delay={0.3} className="mt-8 flex flex-col items-center justify-center gap-3.5 sm:flex-row">
          <a
            data-testid="footer-whatsapp-cta"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 rounded-full bg-wagreen px-9 py-4 text-lg font-bold text-white shadow-[0_20px_50px_-15px_rgba(37,211,102,0.7)] transition duration-300 hover:-translate-y-1.5 hover:shadow-[0_28px_60px_-15px_rgba(37,211,102,0.8)]"
          >
            <WhatsAppIcon className="h-6 w-6" />
            Chatear por WhatsApp Ahora
          </a>
          <a
            data-testid="footer-maps-cta"
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 rounded-full border-2 border-cream/25 px-7 py-4 text-base font-bold text-cream transition duration-300 hover:-translate-y-1.5 hover:border-gold hover:text-gold"
          >
            <Navigation className="h-5 w-5" />
            Cómo llegar
          </a>
        </Reveal>
      </div>

      <div className="relative border-t border-cream/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 py-8 sm:px-8 lg:flex-row lg:px-12">
          <Logo dark />
          <div className="flex flex-col items-center gap-1.5 text-center lg:items-start lg:text-left">
            <p className="text-sm font-semibold text-cream/80">
              C.C. Plaza Quil, Local 57, Guayaquil
            </p>
            <p className="text-xs text-cream/50">
              Lunes a Sábado desde las 9:30 a. m. · 098 071 2611
            </p>
          </div>
          <div className="flex items-center gap-3">
            <a
              data-testid="instagram-link"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram de Global Pastel"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-cream/20 text-cream transition duration-300 hover:-translate-y-1 hover:border-rose hover:bg-rose"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              data-testid="tiktok-link"
              href={TIKTOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok de Global Pastel"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-cream/20 text-cream transition duration-300 hover:-translate-y-1 hover:border-rose hover:bg-rose"
            >
              <TikTokIcon className="h-5 w-5" />
            </a>
          </div>
        </div>
        <div className="border-t border-cream/10 py-4 text-center text-xs text-cream/40">
          © {new Date().getFullYear()} Global Pastel · Decoración de pasteles en
          Guayaquil
        </div>
      </div>
    </footer>
  );
}
